var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_vm._v("Add Employee")]),_c('div',{staticClass:"box-content content-padding"},[_c('EmployeeEditor',{attrs:{"user":_vm.user}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }